export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_TOTAL_RECORDS = 'SET_TOTAL_RECORDS';
export const SET_PAGE = 'SET_PAGE';
export const EDIT_PARTNER_EMPLOYEE = 'EDIT_PARTNER_EMPLOYEE';
export const ADD_PARTNER_EMPLOYEE = 'ADD_PARTNER_EMPLOYEE';
export const DELETE_PARTNER_EMPLOYEES = 'DELETE_PARTNER_EMPLOYEES';
export const PARTNER_EMPLOYEES_LOADING = 'PARTNER_EMPLOYEES_LOADING';
export const PARTNER_EMPLOYEES_FAILURE = 'PARTNER_EMPLOYEES_FAILURE';
export const GET_PARTNER_EMPLOYEES = 'GET_PARTNER_EMPLOYEES';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const VIEWING_PARTNER_INFO = 'VIEWING_PARTNER_INFO';


export const PARTNER_EMPLOYEE_PROGRESS_TYPE={
    GET_PARTNER_EMPLOYEE_LIST:"GET_PARTNER_EMPLOYEE_LIST",
    ADD_PARTNER_EMPLOYEE_PROGRESS:"ADD_PARTNER_EMPLOYEE_PROGRESS",
    EDIT_PARTNER_EMPLOYEE_PROGRESS:"EDIT_PARTNER_EMPLOYEE_PROGRESS",
    DELETE_PARTNER_EMPLOYEE_PROGRESS:"DELETE_PARTNER_EMPLOYEE_PROGRESS"
}

